export default __webpack_public_path__ + "0e20aba3ac03dafc4f33be519b31960e.png";